module.exports = __webpack_public_path__ + "img/light-Path 18@3x.dafbcbe5.png";